import { XMarkIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { useGetAppointmentsLocationDayQuery } from "../../../store/services/CalendarHoursDaysService";
import TabsHeader from "./TabsHeader";
import AppointmentsList from "./AppointmentsList";
import AvailableSlotsList from "./AvailableSlotsList";


export default function AppointmentsDayDialog({
  selectedDay,
  sedeNome,
  sedeRegione,
  onClose,
}: any) {

  const [activeTab, setActiveTab] = useState<"appointments" | "slots">("appointments");

  const [anno, mese, giorno] = selectedDay.dateStr.split("-");

  const { data, isLoading } = useGetAppointmentsLocationDayQuery({
    anno,
    mese,
    giorno,
    sedeChiave: sedeNome,
  });

  const appointments = data?.result?.appuntamenti ?? [];
  const slotDisponibili = data?.result?.slotDisponibili ?? [];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">

      <div className="bg-white min-h-[550px] rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-hidden">

        {/* HEADER */}
        <div className="bg-emerald-800 text-white p-4 flex justify-between items-center">
          <h2 className="text-lg font-bold">
            Appuntamenti - {sedeRegione} - {giorno}/{mese}/{anno}
          </h2>

          <button
            onClick={onClose}
            className="text-white hover:text-gray-200"
          >
            <XMarkIcon className="w-5 h-5" />
          </button>
        </div>

        {/* TAB HEADER */}
        <TabsHeader activeTab={activeTab} setActiveTab={setActiveTab} />

        {/* CONTENT */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-140px)]">

          {activeTab === "appointments" && (
            <AppointmentsList
              appointments={appointments}
              loading={isLoading}
            />
          )}

          {activeTab === "slots" && (
            <AvailableSlotsList slotDisponibili={slotDisponibili} />
          )}

        </div>

      </div>
    </div>
  );
}